import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Loader } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import Footer from '../components/Footer';
import { KnowledgeGraphView } from '../components/knowledge-graph/KnowledgeGraphView';
import { useRepoStackAnalysis } from '../components/knowledge-graph/hooks/useRepoStackAnalysis';

export const KnowledgeGraphPage: React.FC = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const { data, loading, error } = useRepoStackAnalysis(jobId);

  // Loading
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar pageTitle="Scan Profile Snapshot" showDivider />
        <div className="flex-1 flex items-center justify-center pt-24">
          <div className="flex flex-col items-center gap-3">
            <Loader className="w-8 h-8 text-teal-500 animate-spin" />
            <p className="text-sm text-secondary">Loading stack analysis...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // Error or no data
  if (error || !data) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar pageTitle="Scan Profile Snapshot" showDivider />
        <div className="flex-1 flex items-center justify-center pt-24">
          <div className="text-center max-w-md">
            <p className="text-lg font-semibold text-primary mb-2">
              {error || 'No stack analysis data available'}
            </p>
            <Link
              to={`/jobs/${jobId}/results`}
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to results
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar pageTitle="Scan Profile Snapshot" showDivider />
      <main className="flex-1 pt-24">
        <KnowledgeGraphView data={data} jobId={jobId!} />
      </main>
      <Footer />
    </div>
  );
};
